/*------------------------------------*\
    BABEL POLYFILL
\*------------------------------------*/
import "babel-polyfill";

/*------------------------------------*\
    MODULES
\*------------------------------------*/
import TypeMate from 'typemate';
import Navigation from './modules/navigation';
import Accordion from './modules/accordion';
import BackToTop from './modules/back-to-top';
import CustomSelect from './modules/custom-select';
import EventCard from './modules/event-card';
import Graph from './modules/graph';
import MultiCarousel from './modules/multi-carousel';
import FullWidthCarousel from './modules/full-width-carousel';
// import LoadMore from './modules/load-more';
import NewsPagination from "./modules/news-pagination";
import BannerImg from "./modules/banner-image";
import FullwidthCarouselImage from "./modules/fullwidth-carousel-image";
import 'bootstrap';

/*------------------------------------*
    APP
\*------------------------------------*/
const app = {

    init() {
        this.noJs();
        this.alwaysLoad();
        this.bind();
    },

    bind() {

        // Load any items that need modules
        let modulePlaceHolders = [...document.querySelectorAll('[data-module]')];

        // No modules so bail
        if(!modulePlaceHolders.length) {
            return;
        }

        modulePlaceHolders.map((item) => {

            // Attempt to load any modules
            let modules = item.getAttribute('data-module');

            if(!modules.length) {
                return false;
            }

            // Split the modules into an array
            modules = modules.trim().split(',');

            // Loop and bind to relevant modules
            modules.map((module) => {

                switch(module) {
                    case 'accordion':

                        let accordionInstance = new Accordion(item);

                        accordionInstance.init();

                        break;

                    case 'custom-select':

                        let customSelectInstance = new CustomSelect(item);

                        customSelectInstance.init();

                        break;

                    case 'event-card':

                        let eventCardInstance = new EventCard(item);

                        eventCardInstance.init();

                        break;

                    case 'navigation':

                        let navigationInstance = new Navigation(item);

                        navigationInstance.init();

                        break;

                    case 'js-back-to-top':

                        let BackToTopInstance = new BackToTop(item);

                        BackToTopInstance.init();

                        break;

                    case 'js-multi-carousel':

                        let multiCarouselInstance = new MultiCarousel(item);

                        multiCarouselInstance.init();

                        break;
                    case 'js-full-width-carousel':

                        let fullWidthCarouselInstance = new FullWidthCarousel(item);

                        fullWidthCarouselInstance.init();

                        break;
                    case 'js-graph':

                        let graphInstance = new Graph(item);

                        graphInstance.init();

                        break;

                    case 'news-pagination':

                        let newsPaginationInstance = new NewsPagination(item);

                        newsPaginationInstance.init();

                        break;

                    case 'banner-image':

                        let bannerImgInstance = new BannerImg(item);

                        bannerImgInstance.init();

                        break;
                    case 'fullwidth-carousel-image':

                        let fullwidthCarouselImageInstance = new FullwidthCarouselImage(item);

                        fullwidthCarouselImageInstance.init();

                        break;
                }
            });
        });
    },

    alwaysLoad() {
        const typeMateInstance = new TypeMate();
        typeMateInstance.apply();
    },

    noJs() {
        document.documentElement.classList.remove('no-js');
        document.documentElement.classList.add('js');
    }
};

// Launch
app.init();
